// Web fallback for MediaRecorder
let webMediaRecorder = null;
let webAudioChunks = [];
let webAudioStream = null;

/**
 * Start web recording using MediaRecorder API
 * @returns {Promise<Object>} Recording result with status
 */
export const startWebRecording = async () => {
  try {
    console.log('Starting web recording with MediaRecorder...');
    webAudioChunks = [];

    webAudioStream = await navigator.mediaDevices.getUserMedia({
      audio: {
        echoCancellation: false,
        noiseSuppression: false,
        autoGainControl: false,
        sampleRate: 44100,
        channelCount: 1
      }
    });

    webMediaRecorder = new MediaRecorder(webAudioStream, {
      mimeType: 'audio/webm;codecs=opus'
    });

    webMediaRecorder.ondataavailable = event => {
      if (event.data.size > 0) {
        webAudioChunks.push(event.data);
      }
    };

    webMediaRecorder.start();
    console.log('Web recording started successfully');
    return { value: { status: 'RECORDING' } };
  } catch (error) {
    console.error(`Web recording start error: ${error.message}`, error);
    throw error;
  }
};

// Export the shared variables for other modules to use
export { webMediaRecorder, webAudioChunks, webAudioStream };
